/* eslint-disable max-len */
/* eslint-disable react/no-danger */

// Importing necessary modules and hooks
import { useMediaQuery, useTheme } from '@mui/material'; // For handling media queries and theme-related functionality
import React, { useContext, useEffect, useId, useState } from 'react'; // React library for component development
import { useSelector } from 'react-redux'; // Redux selector to access state
import { useNavigate } from 'react-router-dom'; // For navigation between routes
import { NewsFeedContext } from '../../libs/Context'; // Context API for managing global state related to the NewsFeed
import CompanyDropdown from './CompanyDropdown'; // Component for company selection dropdown

// Default fallback image path
const DEFAULT_IMAGE = '/images/logos/In_logo.svg';

// Component interface defining optional prop
interface InLinkLogoProps {
  handleCloseRespSideNav?: () => void; // Optional function to handle side navigation closure
}

// Main functional component
const InLinkLogo: React.FC<InLinkLogoProps> = ({ handleCloseRespSideNav }) =>
{
	// Accessing context and theme for responsive behavior
	const { setMenuItem } = useContext(NewsFeedContext);
	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down(600)); // Checks if screen width is below 600px

	// Accessing Redux state values
	const userData = useSelector((state: any) => state?.mysession?.session);
	const companyDetailsRedux = useSelector((state: any) => state?.mysession?.companyProfile);
	const [ tempId, setTempId ] = useState<any>(useId());
	// Navigation function
	const navigate = useNavigate();

	// Function to handle logo click and navigation
	const handleClick = () =>
	{
		setMenuItem(''); // Resetting menu item state
		navigate('/news'); // Navigating to the news page
	};

	// Function to handle image loading errors
	const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) =>
	{
		const target = e.target as HTMLImageElement;

		target.src = DEFAULT_IMAGE; // Fallback to default image
	};

	useEffect(() =>
	{
		setTempId(Date.now());
	}, [ userData?.companyId, userData?.companyData?.logo?.logoImage, companyDetailsRedux?.logoKey ]);

	// Component rendering
	return (
		<div className='flexMinWidthRow alignCntr pdngXS'>
			<div className='flexMinWidthRow'>
				<div
					className={
						userData?.companyData?.logo?.logoImage && companyDetailsRedux?.logoKey !== null
							? 'flexRow authLogo pointer alignCntr'
							: 'flexRow authLogo alignCntr pointer'
					}
				>
					<>
						{/* Conditionally render the company logo or fallback */}
						{userData?.companyData?.logo?.isLogoEnabled
							? (
								<img
									src={`${process.env.REACT_APP_S3_GET_URL}/profile/${userData?.companyId}_logo_thumbnail.jpeg?t=${tempId}`}
									alt='Company-Logo'
									height='32'
									width='120'
									onError={handleImageError}
									onClick={handleClick}
									loading='lazy'
								/>
							)
							: (
								<img
									src='/images/logos/In_logo.svg'
									alt='Default Logo'
									onClick={handleClick}
									height='32'
									width='120'
								/>
							)}
						{/* Render title if not on small screens */}
						{/* {!downSM && ( */}
						<span className='flexRow alignCntr'>
							{userData?.companyData?.logo?.isTitleEnabled
								? (
									<div
										className='flexInline alignCntr pdngLXXS'
										onClick={handleClick}
										dangerouslySetInnerHTML={{
											__html : userData?.companyData?.logo?.logoTitle || '' // Render HTML content
										}}
									/>
								)
								: (
									<div
										className='flexInline alignCntr pdngLXXS'
										onClick={handleClick}
									>
										{/* // Fallback to company name */}
										{userData?.role === 'individual' ? 'Individual' : userData?.companyData?.companyName}
									</div>
								)}
							{/* Company selection dropdown */}
							<CompanyDropdown userData={userData} tempId={tempId} />
						</span>
						{/* )} */}
					</>
				</div>
			</div>
		</div>
	);
};

export default InLinkLogo;
